import { render, staticRenderFns } from "./AtendimentoContratoRoute.vue?vue&type=template&id=4727dc44"
import script from "./AtendimentoContratoRoute.vue?vue&type=script&lang=js"
export * from "./AtendimentoContratoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports